import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js'
import { getStripe } from '@/services/StripeService/StripePaymentService'
import { useLocale } from '@/utils/LocaleUtil'
import { logger } from '@/utils/logging'
import { EmbeddedStripeCheckoutSessionSkeleton } from './EmbeddedStripeCheckoutSessionSkeleton'

interface EmbeddedStripeCheckoutSessionProps {
  clientSecret?: string | null
  loading?: boolean
  onComplete?: () => void
}

export const EmbeddedStripeCheckoutSession = ({
  clientSecret,
  loading,
  onComplete,
}: EmbeddedStripeCheckoutSessionProps) => {
  const { locale } = useLocale()
  if (!loading && clientSecret) {
    return (
      <EmbeddedCheckoutProvider
        key={clientSecret}
        stripe={getStripe(locale)}
        options={{
          fetchClientSecret: async () => clientSecret,
          onComplete,
        }}
      >
        <EmbeddedCheckout className="w-full" />
      </EmbeddedCheckoutProvider>
    )
  }

  if (!loading && !clientSecret) {
    const errForStackTrace = new Error('Client secret is missing')
    logger().error('Unable to load checkout session', { locale }, errForStackTrace)
    return (
      <div className="flex h-full w-full items-center justify-center p-8">
        <p className="text-center text-lg font-bold">Unable to load checkout session</p>
      </div>
    )
  }

  return <EmbeddedStripeCheckoutSessionSkeleton />
}
